import Button from 'components/Button';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const CypressLawnButton = ({ obituaryUrl, color }) => {
    const [textColor, setTextColor] = useState('#fff');
    const [bgColor, setBgColor] = useState(color);

    return (
        <Button
            text={
                <FormattedMessage
                    id="features.Viewlogy.GuestSection.Form.cypressLawnMemory"
                    defaultMessage="Next, add a memory on the family page"
                />
            }
            className="guest-submit-button"
            onClick={() => {
                const safeUrl = obituaryUrl.startsWith('http') ? obituaryUrl : `https://${obituaryUrl}`;
                window.open(`${safeUrl}#connect-share`, '_blank', 'noopener,noreferrer');
            }}
            onMouseEnter={() => {
                setBgColor('#fff');
                setTextColor(color);
            }}
            onMouseLeave={() => {
                setBgColor(color);
                setTextColor('#fff');
            }}
            style={{
                color: textColor,
                border: `2px solid ${color}`,
                backgroundColor: bgColor,
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                justifyContent: 'center',
                marginTop: '12px',
            }}
        />
    );
};

export default CypressLawnButton;
